import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { PromoCodesQueryKeys } from '../../../constants/query';
import { redeemPromoCode } from '../services/promo-codes.api';
import type { PromotionActionLocation } from '../../../constants/analytics-enums';
import { reportPromoCodeClaim } from '../../../utils/analytics';


export function useClaimPromoCode(
  promoCode: string,
  location: PromotionActionLocation,
  callBack?: () => void
) {
  const [claimError, setClaimError] = useState<string | undefined>(undefined);

  const { mutate: claimPromoCode, isLoading } = useMutation({
    mutationFn: () => redeemPromoCode(promoCode),
    mutationKey: PromoCodesQueryKeys.PROMO_CODE_CLAIM(promoCode),
    onSuccess: () => {
      setClaimError(undefined);
      reportPromoCodeClaim({ location, promoCode });
      callBack?.();
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      const errorMessage = error.response?.data?.message ?? error.message;
      setClaimError(errorMessage);
    },
  });

  return {
    claimPromoCode,
    claimError,
    isLoading,
  }
}
